import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { motion } from 'framer-motion';
import type { ErrorMessageProps } from '../reducers/types';

/**
 * Error message component with retry option
 * 
 * Displays an error message with an optional retry button.
 * The component animates in from the bottom for a smooth appearance.
 * 
 * @param props Component props
 * @returns JSX Element
 */
const ErrorMessage: React.FC<ErrorMessageProps> = t0 => {
  const $ = _c(10);
  const {
    error,
    showRetry,
    onRetry
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 10
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== error) {
    t3 = <span>{error}</span>;
    $[2] = error;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onRetry || $[5] !== showRetry) {
    t4 = showRetry && <button onClick={e => {
      e.stopPropagation();
      onRetry(e);
    }} className="tw-px-3 tw-py-1 tw-bg-primary-500/20 tw-text-primary-300 tw-text-xs tw-rounded-md hover:tw-bg-primary-500/30 tw-transition-colors tw-duration-200" type="button">Try Again</button>;
    $[4] = onRetry;
    $[5] = showRetry;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <motion.div id="file-upload-error" initial={t1} animate={t2} className="tw-absolute tw-bottom-14 tw-px-4 tw-py-2 tw-bg-red/10 tw-border tw-border-red/30 tw-rounded-lg tw-text-red tw-text-sm" role="alert" aria-live="assertive"><div className="tw-flex tw-flex-col tw-gap-2">{t3}{t4}</div></motion.div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default ErrorMessage;